export enum PartnerType {
  Commercial = 'Commercial',
  Distributor = 'Distributor',
}
